import { ILocality } from '../../commomTypes';

// Action Types
export enum Types {
  LOAD_CREDIT_LIMITS_FROM_LOCAL_STORAGE = 'creditLimits/LOAD_CREDIT_LIMITS_FROM_LOCAL_STORAGE',

  LOAD_CREDIT_LIMITS = 'creditLimits/LOAD_CREDIT_LIMITS',
  LOAD_CREDIT_LIMITS_SUCCESS = 'creditLimits/LOAD_CREDIT_LIMITS_SUCCESS',
  LOAD_CREDIT_LIMITS_FAILURE = 'creditLimits/LOAD_CREDIT_LIMITS_FAILURE',

  REQUEST_RENEW_CREDIT_LIMITS = 'creditLimits/REQUEST_RENEW_CREDIT_LIMITS',
  REQUEST_RENEW_CREDIT_LIMITS_SUCCESS = 'creditLimits/REQUEST_RENEW_CREDIT_LIMITS_SUCCESS',
  REQUEST_RENEW_CREDIT_LIMITS_FAILURE = 'creditLimits/REQUEST_RENEW_CREDIT_LIMITS_FAILURE'
}

export interface ICreditLimitsState {
  loading: boolean;
  error: boolean;
  selectedCustomerId: string;
  errorMessage?: string;
  creditLimits?: ICreditLimits | undefined;

  renewCreditLoading?: boolean;
  renewCreditError?: boolean;
  renewCreditAlreadyRequested?: boolean;
}

export interface ICreditLimits extends ICreditLimitsData {
  code: string;
  creditLimit: string;
  creditLimitValidDate: string;
  currency: string;
  name: string;

  locality: ILocality;
  total: ICreditLimitsData;

  subsidiaries: ICreditLimits[];

  openPortifolioUsedCredit: string; // shippingUsedCredit + openOrdersUsedCredit
  openPortifolioUsedCreditPercentage: string; // shippingUsedCreditPercentage + openOrdersUsedCreditPercentage

  parentOpenPortifolioCredit: string; // total.openOrdersUsedCredit + total.shippingUsedCredit
  parentOpenPortifolioCreditPercentage: string; // total.openOrdersUsedCreditPercentage + total.shippingUsedCreditPercentage
}

interface ICreditLimitsData {
  billedUsedCredit: string;
  billedUsedCreditPercentage: string;

  openInvoiceUsedCredit: string;
  openInvoiceUsedCreditPercentage: string;

  openOrdersUsedCredit: string;
  openOrdersUsedCreditPercentage: string;

  shippingUsedCredit: string;
  shippingUsedCreditPercentage: string;

  usedCredit: string;
  usedCreditPercentage: string;
}
